module.exports = __webpack_public_path__ + "img/right_1.23e3a4d2.jpg";